// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { ContextFlag } from "../schema";

export function serialize_ContextFlag_internal(value: ContextFlag): unknown {
  return ((value: "BETA" | "LOGGED_IN" | "LOGGED_IN_ANONYMOUS" | "STRICT_FREE_TEXT_PRIVACY" | "ALPHA"): unknown => {
    return value;
  })(value);
}
export function serialize_ContextFlag(obj: ContextFlag): string {
  return renderJsonWithNumbersAsBigint(serialize_ContextFlag_internal(obj));
}
export function deserialize_ContextFlag_internal(value: unknown): ParserResult<ContextFlag> {
  return ((value: unknown): ParserResult<"BETA" | "LOGGED_IN" | "LOGGED_IN_ANONYMOUS" | "STRICT_FREE_TEXT_PRIVACY" | "ALPHA"> => {
    if (typeof value !== "string") {
      return { success: false, reason: `[#/components/schemas/ContextFlag]: '${value}' expected to be of type string.` };
    }
    switch (value) {
      case "BETA":
        return { success: true, value: "BETA" };
      case "LOGGED_IN":
        return { success: true, value: "LOGGED_IN" };
      case "LOGGED_IN_ANONYMOUS":
        return { success: true, value: "LOGGED_IN_ANONYMOUS" };
      case "STRICT_FREE_TEXT_PRIVACY":
        return { success: true, value: "STRICT_FREE_TEXT_PRIVACY" };
      case "ALPHA":
        return { success: true, value: "ALPHA" };
      default:
        return { success: false, reason: `[#/components/schemas/ContextFlag]: '${value}' expected to be enum, one of 'BETA, LOGGED_IN, LOGGED_IN_ANONYMOUS, STRICT_FREE_TEXT_PRIVACY, ALPHA'.` };
    }
  })(value);
}
export function deserialize_ContextFlag(str: string): ParserResult<ContextFlag> {
  return deserialize_ContextFlag_internal(parseJsonWithNumbersAsBigint(str));
}
